export const FETCH_PRODUCTS_RECEIVE = 'FETCH_PRODUCTS_RECEIVE';
